"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_DATA_SHA_1 = exports.SHA_1_HMAC_ALGO = exports.SHA_1_HASH = void 0;
exports.SHA_1_HASH = { name: "SHA-1" };
exports.SHA_1_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_1_HASH,
};
exports.EMPTY_DATA_SHA_1 = new Uint8Array([
    218,
    57,
    163,
    238,
    94,
    107,
    75,
    13,
    50,
    85,
    191,
    239,
    149,
    96,
    24,
    144,
    175,
    216,
    7,
    9,
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLFVBQVUsR0FBc0IsRUFBRSxJQUFJLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFFbEQsUUFBQSxlQUFlLEdBQThDO0lBQ3hFLElBQUksRUFBRSxNQUFNO0lBQ1osSUFBSSxFQUFFLGtCQUFVO0NBQ2pCLENBQUM7QUFFVyxRQUFBLGdCQUFnQixHQUFHLElBQUksVUFBVSxDQUFDO0lBQzdDLEdBQUc7SUFDSCxFQUFFO0lBQ0YsR0FBRztJQUNILEdBQUc7SUFDSCxFQUFFO0lBQ0YsR0FBRztJQUNILEVBQUU7SUFDRixFQUFFO0lBQ0YsRUFBRTtJQUNGLEVBQUU7SUFDRixHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxFQUFFO0lBQ0YsRUFBRTtJQUNGLEdBQUc7SUFDSCxHQUFHO0lBQ0gsR0FBRztJQUNILENBQUM7SUFDRCxDQUFDO0NBQ0YsQ0FBQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFNIQV8xX0hBU0g6IHsgbmFtZTogXCJTSEEtMVwiIH0gPSB7IG5hbWU6IFwiU0hBLTFcIiB9O1xuXG5leHBvcnQgY29uc3QgU0hBXzFfSE1BQ19BTEdPOiB7IG5hbWU6IFwiSE1BQ1wiOyBoYXNoOiB7IG5hbWU6IFwiU0hBLTFcIiB9IH0gPSB7XG4gIG5hbWU6IFwiSE1BQ1wiLFxuICBoYXNoOiBTSEFfMV9IQVNILFxufTtcblxuZXhwb3J0IGNvbnN0IEVNUFRZX0RBVEFfU0hBXzEgPSBuZXcgVWludDhBcnJheShbXG4gIDIxOCxcbiAgNTcsXG4gIDE2MyxcbiAgMjM4LFxuICA5NCxcbiAgMTA3LFxuICA3NSxcbiAgMTMsXG4gIDUwLFxuICA4NSxcbiAgMTkxLFxuICAyMzksXG4gIDE0OSxcbiAgOTYsXG4gIDI0LFxuICAxNDQsXG4gIDE3NSxcbiAgMjE2LFxuICA3LFxuICA5LFxuXSk7XG4iXX0=